export { default as Splide } from './Splide/Splide.svelte';
export { default as SplideTrack } from './SplideTrack/SplideTrack.svelte';
export { default as SplideSlide } from './SplideSlide/SplideSlide.svelte';
